// extracted by mini-css-extract-plugin
module.exports = {"platformPart":"PlatformPart_platformPart__2Cyyi","buttonsWrapper":"PlatformPart_buttonsWrapper__2TB75"};